import { Component, computed, effect, inject, OnInit, ViewChild } from '@angular/core';
import { PaaService } from '../paa.service';
import { PaaRepository } from '@/store/paa-state/paa-state.repository';
import { ActivatedRoute, Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { DataTableRowActions, DynamicDataTable } from '@/components/data-table-builder/data-table.types';
import { Paa } from '@/types';
import { getPaaVersionHistoryDataTableStructure } from './utils/paa-version-history.data-table-object';
import { DialogComponent } from '@/components/dialog/dialog.component';
import { DialogObject } from '@/components/dialog/dialog.types';
import { PageHeaderComponent } from '../../../components/shared/page-header/page-header.component';
import { DataTableBuilderComponent } from '../../../components/data-table-builder/data-table-builder.component';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { createServerQuery } from '@/components/data-table-builder/server-query';

@Component({
  selector: 'sm-paa-version-history',
  imports: [PageHeaderComponent, DataTableBuilderComponent, DialogComponent, TranslateModule],
  templateUrl: './version-history.component.html',
  styleUrl: './version-history.component.scss',
})
export class PaaVersionHistoryComponent implements OnInit {
  //services
  paaService = inject(PaaService);
  paaRepository = inject(PaaRepository);
  router = inject(Router);
  messageService = inject(MessageService);
  activatedRoute = inject(ActivatedRoute);
  translate = inject(TranslateService);

  id = this.activatedRoute.snapshot.params['id'] as number;

  //breadcrumb
  breadcrumb = [
    {
      label: '',
      routerLink: ['/paa-history'],
    },
  ];
  @ViewChild('dialog') dialogComponent!: DialogComponent;
  paaDialog?: DialogObject;

  serverQuery = createServerQuery({});
  queryParams = computed(() => ({
    page: this.serverQuery.page(),
    pageSize: this.serverQuery.pageSize(),
    sortBy: this.serverQuery.sortBy(),
    sortOrder: this.serverQuery.sortOrder(),
    search: this.serverQuery.search(),
  }));

  rowActions: DataTableRowActions = {
    defaultActions: {
      inspect: {
        label: 'paa.actions.inspect',
      },
    },
    inspectAction: (row: Paa) => {
      this.router.navigate([`paa-inspect-plan`, row.id, row.version]);
    },
  };

  data: Paa[] = [];
  totalRecords = 0;
  datatableObject: DynamicDataTable = getPaaVersionHistoryDataTableStructure({
    store: this.paaRepository,
    rowActions: this.rowActions,
    serverQuery: this.serverQuery,
  });
  loading = true;

  constructor() {
    effect(() => {
      this.serverQuery.page();
      this.serverQuery.pageSize();
      this.serverQuery.search();
      this.serverQuery.sortBy();
      this.serverQuery.sortOrder();
      this.loadData();
    });
  }

  ngOnInit(): void {
    this.loadData();
  }

  redirectUpdatePaa() {
    this.router.navigate(['/paa-edit-plan']);
  }

  loadData() {
    this.paaService
      .getPaaHistory(this.id, {
        page: this.serverQuery.page(),
        size: this.serverQuery.pageSize(),
        sort: this.serverQuery.sortBy() ? `${this.serverQuery.sortBy()},${this.serverQuery.sortOrder()}` : '',
        search: this.serverQuery.search(),
      })
      .subscribe({
        next: data => {
          this.data = data.content;
          this.totalRecords = data.totalElements;
          this.loading = false;
        },
        error: err => {
          this.loading = false;
          this.messageService.add({
            severity: 'error',
            summary: 'Erreur',
            detail: err.error.message || 'Une erreur est survenue lors de la récupération des paas',
          });
        },
      });
    //set breadcrumb
    this.paaService.getPaa(this.id).subscribe({
      next: data => {
        this.paaRepository.set('response', data);
        this.breadcrumb[0].label = this.translate.instant(`paa.pages.version_history`, { paa_ref: data.ref });
      },
      error: err => {
        this.loading = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Erreur',
          detail: err.error.message || 'Une erreur est survenue lors de la récupération des paas',
        });
      },
    });
  }
}
